/* eslint-disable replo/no-tailwind-literal-color */

import React from "react";

import Button from "@replo/design-system/components/button/Button";
import { Combobox } from "@replo/design-system/components/combobox/Combobox";
import twMerge from "@replo/design-system/utils/twMerge";

import { useManageChats } from "../hooks/chat";

function ManageChats() {
  const { chatId, chats, createChatLoading, handleNewChat, handleChatSelect } =
    useManageChats();

  const chatOptions =
    chats?.map((chat) => ({
      value: chat.id,
      displayValue: chat.title,
      label: (
        <div
          className={twMerge(
            "flex items-center justify-between w-full py-3 px-1",
            chat.id === chatId ? "bg-surface" : "hover:bg-surface",
          )}
        >
          <div>{chat.title}</div>
          <div className="text-sm text-muted">
            {new Date(chat.createdAt).toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}
          </div>
        </div>
      ),
    })) ?? [];

  return (
    <div className="flex gap-2">
      <Button
        isLoading={createChatLoading}
        variant="secondary"
        size="base"
        onClick={() => {
          void handleNewChat();
        }}
        disabled={!chatId}
      >
        New Chat
      </Button>
      <div className="">
        <Combobox
          options={chatOptions}
          value={chatId ?? ""}
          onChange={handleChatSelect}
          trigger={
            <Combobox.SelectionButton
              title="Manage Chats"
              placeholder="Select chat..."
            />
          }
          title="Past Chats"
          inputPlaceholder="Search chats..."
        />
      </div>
    </div>
  );
}

export default ManageChats;
